<template>
  <ImageWrapper
    imagePath="assets/images/Teaser_technischerFehler"
    imageName="Teaser_technischerFehler"
    :breakpoints="[300, 300, 353, 353, 353]"
  ></ImageWrapper>
</template>

<script setup lang="ts">
import ImageWrapper from '@/components/rahmen/ImageWrapper.vue'
</script>
